import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReminderRoutingModule } from './reminder-routing.module';
import { WaterReminderComponent } from './water-reminder/water-reminder.component';
import { MaterialModule } from '../shared/material.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from "../shared/shared.module";
import { MatDialogModule } from '@angular/material/dialog';
import { ReminderComponent } from './reminder.component';
import { SleepReminderComponent } from './sleep-reminder/sleep-reminder.component';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { MedicineReminderComponent } from './medicine-reminder/medicine-reminder.component';
import { CustomReminderComponent } from './custom-reminder/custom-reminder.component';
// import { MAT_DATE_LOCALE } from '@angular/material/core';
@NgModule({
  declarations: [
    WaterReminderComponent,
    ReminderComponent,
    SleepReminderComponent,
    MedicineReminderComponent,
    CustomReminderComponent,
  ],
  imports: [
    NgxMatTimepickerModule,
    CommonModule,
    ReminderRoutingModule,
    MaterialModule,
    MatInputModule,
    MatFormFieldModule,
    SharedModule,
    MatDialogModule
  ],
  // providers: [
  //   { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  // ]
})
export class ReminderModule { }
